import { IncomingMessage } from 'http';
import { buildAPIUrl, responseInterceptor } from './';
import { getVirtualIP } from '@/utils';

export const getPageData = async (
  resolvedUrl: string,
  locale: string | undefined,
  defaultLocale: string | undefined,
  req: IncomingMessage | undefined,
  accessToken?: string | null,
): Promise<Response> => {
  const fetchUrl = new URL(`${await buildAPIUrl(req)}${defaultLocale !== locale ? '/' + locale : ''}${resolvedUrl}`);
  fetchUrl.pathname = fetchUrl.pathname.endsWith('/') ? fetchUrl.pathname.slice(0, -1) : fetchUrl.pathname;
  const headerAuthorization = req?.headers.authorization;

  return responseInterceptor(
    await fetch(fetchUrl.href, {
      keepalive: true,
      redirect: 'manual',
      headers: new Headers({
        ...(headerAuthorization && { Authorization: headerAuthorization }),
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
        Cookie: req?.headers.cookie || '',
        'client-ip': getVirtualIP(req || {}),
      }),
    }),
    resolvedUrl,
    true,
  );
};
// Fetch translation messages for a given locale
// https://uat-web-api.testing-stylus.com/umbraco/dictionaries.json?l=en-GB
export const getTranslationMessages = async (locale: string): Promise<Record<string, string>> => {
  const apiURL = new URL(process.env.API_URL || 'https://uat-web-api.testing-stylus.com/');
  const endpoint = `${apiURL}umbraco/dictionaries.json?l=${locale}`;

  const res = await fetch(endpoint);
  if (!res.ok) {
    throw new Error(`Failed to fetch translations: ${res.statusText}`);
  }

  return res.json();
};

export const getSecureDownloadLink = async (linkHref: string): Promise<{ data: { redirectTo: string } }> => {
  const fetchUrl = new URL(`${await buildAPIUrl()}${linkHref}`);
  const res = await fetch(fetchUrl);
  if (!res.ok) {
    throw new Error(`Failed to fetch secureDownloadLink: ${res.statusText}`);
  }
  return res.json();
};
